<template>
	<div class="wraps_">
		<div class="counts">
			<el-page-header @back="$router.go(-1)" content="申请专家文库" />
			<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
				<el-card class="box-card  xiangxi">
					<el-form-item label="专家姓名" prop="relname">
						<el-input v-model="form.relname" placeholder="请填写专家姓名"></el-input>
					</el-form-item>
					<el-form-item label="头像"  prop="headimg">
						<el-upload class="avatar-uploader" :action="picUrl" 
							:show-file-list="false"
							element-loading-text="拼命加载中……"
							:on-progress="change"
							:before-upload="beforeAvatarUpload"
							v-loading.fullscreen.lock="loading"
							:data="fileInfo"
							element-loading-background="rgba(250, 250, 250, 0.3)"
							:on-success="handleAvatarSuccess" accept="image/jpeg,image/png">
							<img v-if="headimg" :src="headimg"  :onerror="imgSrc" class="avatar">
							<!-- :onerror="imgSrc" -->
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<div class="tishinews">
							小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
						</div>
					</el-form-item>
					<el-form-item label="毕业院校" prop="biye">
						<el-input v-model="form.biye" placeholder="请填写毕业院校"></el-input>
					</el-form-item>
					<el-form-item label="所属行业" prop="cat_id">
						<el-select v-model="form.cat_id " placeholder="请选择所属行业">
							<el-option v-for="item in catList" :key="item.id" :label="item.catname" :value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item label="所在地" prop="xian">
						<area-select :data="pca" type="text" v-model="selected2" @change="getSite2"
							placeholder="请选择"></area-select>
					</el-form-item>
					<el-form-item label="详细地址" prop="address">
						<el-input v-model="address" placeholder="请填写详细地址"></el-input>
					</el-form-item>
					<el-form-item label="所在单位" prop="danwei">
						<el-input v-model="form.danwei" placeholder="请填写所在单位"></el-input>
					</el-form-item>
					<el-form-item label="从业时间" prop="congye_age">
					  <el-date-picker v-model="form.congye_age" type="date" placeholder="选择从业时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
					  </el-date-picker>
					</el-form-item>
					<el-form-item label="职位/职称" prop="zhiwei">
						<el-input v-model="form.zhiwei" placeholder="请填写职位/职称"></el-input>
					</el-form-item>
				</el-card>
				<el-card class="box-card">
					<div slot="header">
						<span>基本信息</span>
					</div>
					<el-input type="textarea" style="height: 192px !important;" v-model="form.jianjie"></el-input>
				</el-card>
				<el-card class="box-card">
					<div slot="header">
						<span>成功案例</span>
					</div>
					<el-input type="textarea" style="height: 192px !important;"  v-model="form.anli "></el-input>
				</el-card>
				<el-card class="box-card">
					<div slot="header">
						<span>专家专长</span>
					</div>
					<el-input type="textarea"  style="height: 192px !important;" v-model="form.zhuanchang"></el-input>
				</el-card>
				<el-card class="box-card">
					<div slot="header">
						<span>提供服务</span>
					</div>
					<el-input type="textarea" style="height: 192px !important;"  v-model="form.fuwu"></el-input>
				</el-card>
				<div class="sq">
					<el-button type="primary" @click="tjsq">提交申请</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {
		pca,
		pcaa
	} from 'area-data'
	import 'vue-area-linkage/dist/index.css'
	import Axios from 'axios'
	export default {
		data() {
			return {
				address1: [], // 接收数据的对象
				selected2: [],//地区
				pca: pca,
				pcaa: pcaa,
				ruleForm: [],
				zj_state:localStorage.getItem("zj_state"),
				catList: [],
				headimg:'',
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				picUrl:this.$store.state.BASE_URL + '/uploadImgOne.html',
				loading: false,
				address:'', //详细地址
				form:{
					sheng:'',
					shi:'',
					address:'',
					headimg:'', //头像
					relname:'',//专家姓名
					biye:'', //毕业
					cat_id:'',//行业
					danwei:'',//单位
					congye_age:'',//
					zhiwei:'',//职位
					jianjie:'',//基本信心
					anli:'',//案例
					zhuanchang:'',//专业专场
					fuwu:'',//服务
					user_id:this.$store.state.USER_ID
				},
				fileInfo: {
					type: "Member",
				},
				rules: {
					relname: [{
						required: true,
						message: '请输入专家姓名'
					}],
					headimg: [{
						required: true,
						message: '请上传专家头像'
					}],
					biye: [{
						required: true,
						message: '请填写专家毕业院校'
					}],
					cat_id: [{
						required: true,
						message: '请选择所属行业'
					}],
					danwei: [{
						required: true,
						message: '请填写所在单位'
					}],
					congye_age: [{
						required: true,
						message: '请选择从业时间'
					}],
					zhiwei: [{
						required: true,
						message: '请填写职位/职称'
					}],
					zhiwei: [{
						required: true,
						message: '请填写职位/职称'
					}],
					xian:[{
						required: true,
						message: '请选择地区'
					}],
					address:[{
						required: true,
						message: '请填写详细地址'
					}]
					
				}
			}
		},
		beforeCreate() {
			 // if(this.zj_state == 1){
				//  //  1 正常 
				//  this.$router.push('/experList')
				// // this.$confirm('提交成功，请等待工作审核（审核时间1-3个工作日）', '提示', {
				// // 	type: 'success',
				// // 	showCancelButton: false
				// // }).then(() => {
					
				// // }) 
			 // }
			 // if(this.zj_state == 2){
				//  //  2 驳回 
				// this.$confirm("您的申请已驳回,请重新申请", '提示', {
				// 	type: 'warning',
				// 	showCancelButton: false
				// }).then(() => {
				// 	this.$router.push('/')
				// })
			 // }
			
			
		},
		created() {
			 this.getCate()
			 this.getnews()
		},
		methods: {
			getnews(){
				Axios.post('Myseller-setting-getZhuanjiaInfo',this.$qs.stringify({user_id:this.$store.state.USER_ID})).then(res => {
					if(res.data.data != null ){
						this.form = res.data.data
						this.headimg = res.data.data.headimg ? this.$store.state.IMG_URL+res.data.data.headimg  : ''
						this.address = res.data.data.address
						this.selected2.push(this.data.data.sheng, this.data.data.shi)
					}
					
					
				})
			},
			tjsq() {
				this.form.address = this.form.sheng + this.form.shi + this.address
				this.$axios.post('Myseller-setting-saveZhuanjiaInfo', this.form).then(res => {
					if(res.code == 200){
						this.$alert(res.msg, '提示', {
							type: 'success',
							confirmButtonText: '确定',
							callback: action => {
								this.router.push("")				  
							}
						})
					}else{
						this.$alert(res.msg, '提示', {
							type: 'error',
							confirmButtonText: '确定',
						})
					}
				})
			},
			getSite2(data) {
				this.form.sheng = data[0]
				this.form.shi = data[1]
				this.form.address = this.form.sheng+this.form.shi
			},
			getCate(){
				
				this.$axios.post('Myseller-setting-getChildrenCategory',{user_id:this.$store.state.USER_ID}).then(data => {
					this.catList = data
				})
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			change(event, file, fileList) {
				this.loading = true;
			},
			handleAvatarSuccess(res, file) {
				if(res.src != null || res.src != undefined ){
					this.loading = false;
					this.form.headimg = res.src
					this.headimg =this.$store.state.IMG_URL+res.src
					this.headimg = URL.createObjectURL(file.raw);
					this.$message.success("上传成功")
				}else{
					this.loading = false;
					this.$message.error(res.data)	
				}
				
				
			},
		},
	}
</script>

<style scoped>
	.wraps_ {
		background: #f8f8f8;
	}
	.wraps_ .el-form-item__content {
		margin-left: 29px !important;
	}
	.wraps_ .sq {
		height: 80px;
		background-color: #fff;
		text-align: center;
	}
	.wraps_ .el-button{
		margin: 20px auto !important;
	}
	.box-card{
		margin-top: 20px;
	}
	.box-card>>>.el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 180px !important;
		height: 180px !important;
	}
	
	.box-card>>>.el-upload:hover {
		border-color: #409EFF;
	}
	.avatar-uploader{
		width: 178px !important;
		height: 178px !important;
		line-height: 178px !important;
	}
	.box-card>>>.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	
	.xiangxi>>>.el-input {
		width: 320px;
		margin-right: 20px;
	}
	.area-select-wrap{
		display: flex;
	}
	.area-select-wrap>>>.area-select {
		height: 40px;
	}
	.area-select-wrap>>>.area-selected-trigger {
		padding: 0 20px 0 12px;
	}
	.tox-tinymce-aux {
		z-index: 709826033 !important;
	}
	.el-card__body>>>.el-textarea{
		height: 192px !important;
	}
	.demo-ruleForm>>>.area-select {
		height: 40px;
		line-height: 26px;
		margin-left: 0;
	}
	/* 站过来得 */
	.wraps_>>>.area-select {
		height: 40px;
		line-height: 40px;
		margin-left: 3px;
		margin-bottom: 10px;
	}
	.el-textarea>>>.el-textarea__inner{
		/* width: 320px !important; */
		min-height: 192px !important;
		height: 192px !important;
	}
</style>
